var $j = jQuery.noConflict();

$j(document).ready(function ($) {

    $('.photo-modal').click(function (event) {
        event.preventDefault();
        var img = $(this).find('img').clone();

        if (img.data('imgUrl')){
            img.attr("src", img.data('imgUrl'));
        }
        img.addClass('thumbnail');
        $('#modal-photos .modal-body').html(img);
        $('#modal-photos').modal('show');
    });
    $('.show-subtitles-options').popover({
        html : true,
        content : function() {
            return $(this).next('.subtitles-options').html();
        },
        placement: 'top',
        template: '<div class="popover subtitles-popover bgnoise bgnoise--default"><div class="arrow"></div><div class="popover-inner"><h3 class="popover-title"></h3><div class="popover-content"><p></p></div></div></div>'
    });

    function synopsisUseReadMoreLink(elem, trigger, maxNumberOfLine) {
        elem = $(elem);
        trigger = $(trigger);
        maxNumberOfLine = maxNumberOfLine ? maxNumberOfLine : 10;
        var elemHeight = [];
        elemHeight["reduced"] = Math.round(parseFloat(elem.css('line-height')) * maxNumberOfLine);

        function getElemHeight() {
            elem.height('auto');
            elemHeight["opened"] = parseFloat(elem.height());

            //show only the max number of line
            if (elemHeight["opened"] > elemHeight["reduced"]) {
                if (!trigger.hasClass('opened')) {
                    elem.height(elemHeight["reduced"]).css('overflow', 'hidden');
                }
                trigger.show();
            } else {
                trigger.hide();
            }

            return elemHeight;
        }
        getElemHeight();
        window.onresize = function () {
            getElemHeight();
        };

        trigger.click(function (event) {
            event.preventDefault();
            if (trigger.hasClass('opened')) {
                elem.animate({height: elemHeight["reduced"]}, '500');
                trigger.removeClass('opened');
                trigger.text(Translator.trans('read-more.film.show.title', {}, 'messages'));
            } else {
                elem.animate({height: elemHeight["opened"]}, '500');
                trigger.addClass('opened');
                trigger.text(Translator.trans('reduce-the-text', {}, 'messages'));
            }
        });

    }
    synopsisUseReadMoreLink('.synopsis-mask', 'a.synopsis-read-more', 3);
});
